module.exports = __webpack_public_path__ + "assets/img/white-customer-1.bd1a200a.png";